import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { Router } from '@angular/router';
import {
  CharterPayoutRequest,
  PayoutDAO,
} from '../../../../core/services/dao/payoutDAO';
import * as moment from 'moment';
import { Moment } from 'moment';
import { DialogsService } from '../../../../core/services/dialog.service';
import { CrewMemberDAO } from '../../../../core/services/dao/crewMemberDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';
import { AppCalendarComponent } from '../../../shared/calendar/app-calendar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConstantMan } from '../../../../core/services/constantMan';
import { CalendarOptions } from '@fullcalendar/angular';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { VesselRateCalculationService } from '../../../../core/services/vessel-rate-calculation-service';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { VesselRateDAO } from '../../../../core/services/dao/vesselRateDAO';
import { Observable, Subject, Subscription } from 'rxjs';
import { incrementBaseFeeForDefaultCrewAdditions } from '../../../../core/pure-functions/charter-pricing-helpers';
import { map, startWith } from 'rxjs/operators';
import { UserSearchDialogService } from '../../../shared/dialogs/user-search-dialog/user-search-dialog-service';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { MooringLocationDAO } from '../../../../core/services/dao/mooringLocationDAO';
import {
  CharterConflictRequest,
  VesselAvailabilityPreferencesDAO,
} from '../../../../core/services/dao/vesselAvailabilityPreferencesDAO';
import { CharterVesselAvailabilityDAO } from '../../../../core/services/dao/charterVesselAvailabilityDAO';
import { CharterNoteDAO } from '../../../../core/services/dao/charterNoteDAO';
import * as intlTelInput from 'intl-tel-input';
import { dateSessionStorageFormat } from '../../../buyflow-home/buyflow-home.component';
import { ProductConflict } from 'anchor-shared/lib/model/interface/productConflict';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  CustomerAddOn,
  RequiredAddOnUnitType,
} from 'anchor-shared/lib/model/entity/addOn';
import { getAddOnCost } from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';
import { PricingMetaData } from 'anchor-shared/lib/model/interface/pricingMetaData';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddCharterComponent
  implements OnInit, OnDestroy, ContainsSubscriptions, AfterViewInit
{
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  @ViewChild(AppCalendarComponent)
  appCalendarComponent: AppCalendarComponent;
  charterForm: FormGroup;
  numOfServices = [];
  numOfDiscounts = [];
  numOfCrew = [];
  captains: Captain[];
  boats: Vessel[];
  selectedCaptain: any;
  servicesValid = true;
  discountsValid = true;
  startTimeMeridian: string;
  crewMembers: Partial<CrewMember>[];
  showAllocationWarning = false;
  calendarOptions: CalendarOptions;
  filteredVessels: Observable<Vessel[]>;
  filteredCaptains: Observable<Captain[]>;
  filteredCrew: Observable<Partial<CrewMember>[]>;
  services = [
    {
      name: '',
      cost: undefined,
      show: true,
      requiredError: false,
      valid: true,
    },
  ];
  discounts = [
    {
      name: '',
      amount: undefined,
      show: true,
      requiredError: false,
      valid: true,
    },
  ];
  model: Partial<Charter>;
  charterDateFormatSpecification = 'MM-DD-YYYY';
  durationRadio: string;
  timeRegEx = /([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])/;
  priceRegEx = /^-?\d*\.?\d*$/;
  date: string;
  selectedBoat = {} as Vessel;
  customDuration = 4;
  halfDayDuration = 4;
  fullDayDuration = 8;
  ownerId = null;
  addedCrew = [];
  crewIds = [];
  currentSelectedCrew: any;
  user: User;
  currencyMask: any;
  loading = false;
  showPriceDetailButton = false;
  showApprovedCaptains = true;
  subs: Subscription[] = [];
  calendarBoatChange = new Subject<number>();
  preferredCaptains: any[] = [];
  durationChangeValue: number;
  charterPayoutRequest: CharterPayoutRequest;
  charterTimezone: string;
  waterBodyId: number;
  captainList: Partial<Captain[]> = [];
  charterNotes: string;
  emailTaken: boolean;
  isMobile: boolean;

  constructor(
    private vesselAvailabilityPreferencesDAO: VesselAvailabilityPreferencesDAO,
    private captainDao: CaptainDAO,
    private boatDao: VesselDAO,
    private charterDao: CharterDAO,
    private payoutDao: PayoutDAO,
    private userDao: UserDAO,
    private waterBodyDao: WaterBodyDAO,
    private mooringLocationDao: MooringLocationDAO,
    private router: Router,
    private dialogService: DialogsService,
    private crewMemberDao: CrewMemberDAO,
    private numFormatter: NumberFormatterService,
    private snackBar: MatSnackBar,
    private vesselRateCalculationService: VesselRateCalculationService,
    private vesselRateDAO: VesselRateDAO,
    private userDAO: UserDAO,
    private userSearchDialogService: UserSearchDialogService,
    private charterVesselAvailabilityDAO: CharterVesselAvailabilityDAO,
    private charterNoteDAO: CharterNoteDAO,
    private breakpointObserver: BreakpointObserver,
  ) {
    const captainSub = this.captainDao
      .adminActiveCaptainList()
      .subscribe((captains) => {
        this.captains = captains;
        this.sortCaptains(this.captains);
      });
    const crewSub = this.crewMemberDao.get().subscribe((crew) => {
      this.crewMembers = crew;
      this.sortCrewMembers(this.crewMembers);
    });
    this.subs.push(captainSub, crewSub);

    this.initServices();
    this.initDiscounts();
    this.currencyMask = this.numFormatter.createPriceMask();
    this.startTimeMeridian = 'am';
    this.searchFxn = this.searchFxn.bind(this);

    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(breakpointSub);
  }

  private createCalendarOptions(): void {
    this.calendarOptions = {
      displayEventTime: false,
      events: null,
    };
  }

  ngAfterViewInit(): void {
    const intlTelInputInstance = intlTelInput;
    this._intlTelInput = intlTelInputInstance(
      this._inputElement.nativeElement,
      { preferredCountries: ['us', 'mx'] },
    );
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model.customerPhoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (!!value) {
      this._intlTelInput.setNumber(value);
    }
    this.model.customerPhoneNumber = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasInvalidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.initModel();
    this.charterForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required]),
      numOfPassengers: new FormControl('', [Validators.required]),
      crewFirstName: new FormControl('', []),
      crewLastName: new FormControl('', []),
      date: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [
        Validators.pattern(this.timeRegEx),
        Validators.required,
      ]),
      startTimeMeridian: new FormControl('', [Validators.required]),
      duration: new FormControl('', [Validators.required]),
      customDuration: new FormControl('', []),
      boat: new FormControl('', [Validators.required]),
      boatName: new FormControl('', []),
      boatMake: new FormControl('', []),
      boatModel: new FormControl('', []),
      boatOwnerFirstName: new FormControl('', []),
      boatOwnerLastName: new FormControl('', []),
      boatOwnerEmail: new FormControl('', []),
      captain: new FormControl('', []),
      crew: new FormControl('', []),
      boatOwnerPhone: new FormControl('', []),
      captainFirstName: new FormControl('', []),
      captainLastName: new FormControl('', []),
      captainEmail: new FormControl('', []),
      captainPhoneNumber: new FormControl('', []),
      notes: new FormControl('', []),
      depositAmount: new FormControl('', []),
      charterTotal: new FormControl('', [Validators.required]),
      fuelCostPerGallon: new FormControl({ value: '', disabled: true }, [
        Validators.required,
      ]),
    });
    const boatSub = this.boatDao
      .loadForCharterPages()
      .subscribe((charterVessels) => {
        this.boats = charterVessels;
        this.sortBoats(this.boats);
        this.filteredVessels = this.charterForm.controls.boat.valueChanges.pipe(
          startWith(''),
          map((name) => this.filterVessels(name)),
        );
        this.filteredCaptains =
          this.charterForm.controls.captain.valueChanges.pipe(
            startWith(''),
            map((name) => this.filterCaptains(name)),
          );
        this.filteredCrew = this.charterForm.controls.crew.valueChanges.pipe(
          startWith(''),
          map((name) => this.filterCrew(name)),
        );
      });
    this.subs.push(boatSub);
    this.user = this.userDao.getCurrentUser();
    this.createCalendarOptions();
  }

  searchFxn(searchText): Observable<UserSearchResult[]> {
    return this.userDAO.adminUserSearch(searchText);
  }

  userSearchClick(): void {
    const sub = this.userSearchDialogService
      .open({ searchFxn: this.searchFxn })
      .subscribe((userSelection) => {
        if (userSelection) {
          this.model.customerEmail = userSelection.email;
          this.model.customerFirstName = userSelection.firstName;
          this.model.customerLastName = userSelection.lastName;
          this.model.customerPhoneNumber = userSelection.phoneNumber;
          this.model.userId = userSelection.id;
          this.emailBlurred(this.model.customerEmail);
          this.snackBar.open('Customer has been added to charter.', null, {
            duration: 4000,
            verticalPosition: 'top',
          });
        }
      });
    this.subs.push(sub);
  }

  filterVessels(val: string): Vessel[] {
    return this.boats.filter((s) => new RegExp(val, 'gi').test(s.name));
  }

  filterCaptains(val: string): Captain[] {
    return this.captains.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  emailBlurred(emailString: string) {
    this.userDAO
      .checkEmail<{ emailDuplicate: boolean }>(emailString, this.model.id)
      .subscribe((res) => {
        if (res.emailDuplicate && !this.model.userId) {
          this.emailTaken = res.emailDuplicate;
          this.charterForm.controls.email.setErrors({ error: true });
        } else {
          this.emailTaken = false;
          this.charterForm.controls.email.setErrors({ error: false });
          this.charterForm.controls.email.updateValueAndValidity();
        }
      });
  }

  filterCrew(val: string): Partial<CrewMember>[] {
    return this.crewMembers.filter((s) =>
      new RegExp(val, 'gi').test(s.user.firstName + ' ' + s.user.lastName),
    );
  }

  requireCost(i) {
    if (this.services[i].name !== '' && !this.services[i].cost) {
      this.services[i].requiredError = true;
      this.servicesValid = false;
    }
  }

  requireDiscountCost(i) {
    if (this.discounts[i].name !== '' && !this.discounts[i].amount) {
      this.discounts[i].requiredError = true;
      this.discountsValid = false;
    }
  }

  sortCrewMembers(members) {
    members.sort((a, b) => {
      if (a.user.lastName.toLowerCase() < b.user.lastName.toLowerCase()) {
        return -1;
      }
      if (a.user.lastName.toLowerCase() > b.user.lastName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  sortBoats(boats) {
    boats.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  dateInPast(): boolean {
    if (this.date) {
      return moment(this.date, this.charterDateFormatSpecification).isBefore(
        moment().startOf('day'),
      );
    } else {
      return false;
    }
  }

  checkIfValidPrice(i) {
    this.services[i].requiredError = false;
    if (this.services[i].cost) {
      this.services[i].valid = true;
      this.servicesValid = true;
    } else {
      this.services[i].valid = false;
      this.servicesValid = false;
    }
  }

  checkIfValidDiscount(i) {
    this.discounts[i].requiredError = false;
    if (this.discounts[i].amount) {
      this.discounts[i].valid = true;
      this.discountsValid = true;
    } else {
      this.discounts[i].valid = false;
      this.discountsValid = false;
    }
  }

  sortCaptains(captains) {
    captains.sort((a, b) => {
      if (a.user && b.user) {
        if (a.user.lastName.toLowerCase() < b.user.lastName.toLowerCase()) {
          return -1;
        }
        if (a.user.lastName.toLowerCase() > b.user.lastName.toLowerCase()) {
          return 1;
        }
      }
      return 0;
    });
  }

  initServices() {
    let i = 0;
    while (i < 20) {
      this.numOfServices.push(i);
      if (i > 0) {
        this.services.push({
          name: '',
          cost: undefined,
          show: false,
          requiredError: false,
          valid: true,
        });
      }
      i++;
    }
  }

  initDiscounts() {
    let i = 0;
    while (i < 20) {
      this.numOfDiscounts.push(i);
      if (i > 0) {
        this.discounts.push({
          name: '',
          amount: undefined,
          show: false,
          requiredError: false,
          valid: true,
        });
      }
      i++;
    }
  }

  initModel() {
    this.model = {
      vesselId: null,
      captainId: null,
      customerFirstName: '',
      customerEmail: '',
      numOfPassengers: null,
      boatName: '',
      boatMake: '',
      boatModel: '',
      boatOwnerFirstName: '',
      boatOwnerLastName: '',
      boatOwnerEmail: '',
      boatOwnerPhone: '',
      captainFirstName: '',
      captainLastName: '',
      captainEmail: '',
      captainPhoneNumber: '',
      date: null,
      duration: null,
      startTime: null,
      charterEndTime: null,
      charterBaseFee: null,
      serviceTotal: 0,
      fuelCost: null,
      createdAt: null,
      depositAmount: 500,
      open: true,
      completed: false,
      cancelled: false,
      crew: null,
      services: null,
      discounts: null,
      depositPayed: false,
      paymentRequested: false,
      paymentReceived: false,
      depositStatus: 'NOT SENT',
      remainderStatus: 'NOT SENT',
      userId: null,
      payouts: [],
      originalRates: [],
    };
  }

  selectBoat(event, vessel: Vessel) {
    if (event.isUserInput) {
      const boatSub = this.boatDao
        .loadById(vessel.id)
        .subscribe((foundBoat) => {
          const timeZoneSub = this.boatDao
            .timezoneById(vessel.id)
            .subscribe((timeZone) => {
              this.charterTimezone = timeZone.timezone;
              const rateSub = this.vesselRateDAO
                .getByVesselId(vessel.id)
                .subscribe((boatRates) => {
                  const boat = foundBoat;
                  boatRates.forEach((rate) => {
                    this.model.originalRates.push(rate);
                  });
                  this.calendarBoatChange.next(boat.id);
                  this.resetCaptainList(boat);
                  this.model.boat = boat;
                  this.model.vesselId = boat.id;
                  this.model.boatName = boat.name;
                  this.model.boatMake = boat.make;
                  this.model.boatModel = boat.model;
                  this.model.boatOwnerFirstName = boat.owner.user.firstName;
                  this.model.boatOwnerLastName = boat.owner.user.lastName;
                  this.model.boatOwnerEmail = boat.owner.user.email;
                  this.model.boatOwnerPhone = boat.owner.user.phoneNumber;
                  this.model.originalRates = [];
                  this.model.depositAmount = boat.depositAmount;
                  if (!this.model.itinerary) {
                    this.model.itinerary = {
                      captainNotes: '',
                      headCaptain: '',
                      locationNotes: '',
                      parkingInstructions: '',
                      passengerNotes: '',
                      rulesOfTheBoat: '',
                      sent: '',
                    };
                  }
                  this.model.itinerary.rulesOfTheBoat =
                    boat.instructionsAndRules;
                  this.model.itinerary.parkingInstructions = boat.parkingNotes;
                  this.charterForm.value.boat = boat;
                  this.charterForm.value.boatName = boat.name;
                  this.charterForm.value.boatMake = boat.make;
                  this.charterForm.value.boatModel = boat.model;
                  this.charterForm.value.depositAmount = boat.depositAmount;
                  this.selectedBoat = boat;
                  this.ownerId = boat.ownerId;
                  if (
                    boat.mooringLocation.parkingLat &&
                    boat.mooringLocation.parkingLong
                  ) {
                    let latlongObj = {
                      mapLatitude: boat.mooringLocation.parkingLat,
                      mapLongitude: boat.mooringLocation.parkingLong,
                    };
                    const latlongSub = this.waterBodyDao
                      .findClosestWaterBodyToLatLong(latlongObj)
                      .subscribe((waterBody) => {
                        this.model.waterBodyId = waterBody.id;
                      });
                    this.subs.push(latlongSub);
                  } else if (
                    boat.vesselWaterBodyMap &&
                    boat.vesselWaterBodyMap.length
                  ) {
                    this.model.waterBodyId = timeZone.waterBodyId;
                  }
                  if (this.appCalendarComponent) {
                    this.appCalendarComponent.selectedBoatId = boat.id;
                  }
                  if (boat.fuelIncluded) {
                    this.model.fuelCost = 0;
                  } else {
                    this.model.fuelCost = boat.fuelBillingRate;
                  }
                });
              this.subs.push(rateSub);
            });
          this.subs.push(timeZoneSub);
        });
      this.subs.push(boatSub);
    }
  }

  selectCaptain(event, captain: Captain, bypass?: boolean) {
    if (event.isUserInput || bypass) {
      let getCaptainSub = this.captainDao
        .getByCaptainId(captain.id)
        .subscribe((newCaptain) => {
          console.log('captain selected');
          console.log(captain);
          const firstName = newCaptain.user.firstName;
          const lastName = newCaptain.user.lastName;
          const email = newCaptain.user.email;
          const phoneNumber = newCaptain.user.phoneNumber;
          this.model.captainId = newCaptain.id;
          this.selectedCaptain = newCaptain;
          console.log(this.selectedCaptain);
          this.model.captainFirstName = firstName;
          this.model.captainLastName = lastName;
          this.model.captainEmail = email;
          this.model.captainPhoneNumber = phoneNumber;
          this.charterForm.value.captain = newCaptain;
          this.charterForm.value.captainFirstName = firstName;
          this.charterForm.value.captainLastName = lastName;
        });
      this.subs.push(getCaptainSub);
    }
  }

  selectCrewMember(event, member: CrewMember) {
    if (event.isUserInput) {
      console.log('crew selected');
      console.log(member);
      console.log(this.charterForm.controls.crew);
      this.currentSelectedCrew = member;
    }
  }

  addCrewMember() {
    this.addedCrew.push(this.currentSelectedCrew);
    this.crewIds.push(this.currentSelectedCrew.id);
    this.crewMembers = this.crewMembers.filter(
      (crewMember) => crewMember.id !== this.currentSelectedCrew.id,
    );
    this.currentSelectedCrew = null;
    this.charterForm.controls.crew.reset('');
    this.updateCharterPricing();
    this.model.duration = this.getIntegerFromDurationRadio();
  }

  increaseServiceNum() {
    let done;
    this.services.forEach((el) => {
      if (!el.show && !done) {
        el.show = true;
        done = true;
      }
    });
  }

  increaseDiscountNum() {
    let done;
    this.discounts.forEach((el) => {
      if (!el.show && !done) {
        el.show = true;
        done = true;
      }
    });
  }

  durationRadioChange(): void {
    this.updateCharterPricing();
    this.checkForMatchingProducts();
  }

  customHoursChange(): void {
    if (
      !this.selectedBoat?.id &&
      !this.date &&
      this.getIntegerFromDurationRadio() > 0
    )
      return;
    const productRatesSub = this.vesselRateDAO
      .getProductAdjustedRates(
        this.selectedBoat.id,
        this.date,
        this.getIntegerFromDurationRadio(),
      )
      .subscribe((productAdjustedRates) => {
        this.model.charterBaseFee = productAdjustedRates.charterBaseFee;
        this.model.boat.vesselRates = this.model.originalRates =
          productAdjustedRates.vesselRates;
        this.showPriceDetailButton = true;
      });
    this.subs.push(productRatesSub);
  }

  cancel() {
    this.router.navigate(['manage', 'charters']);
  }

  setDateAndTimes() {
    this.model.duration = this.getIntegerFromDurationRadio();
    const momentTime = this.getTimeMoment();
    // @ts-ignore
    this.model.date = moment(
      this.date,
      this.charterDateFormatSpecification,
    ).set({
      hour: momentTime.get('hour'),
      minute: momentTime.get('minute'),
    });
    this.model.charterEndTime = moment(
      this.model.date,
      this.charterDateFormatSpecification,
    )
      .add(this.model.duration, 'hours')
      .format('h:mm a');
    this.model.startTime = this.model.startTime + ' ' + this.startTimeMeridian;
  }

  private getTimeMoment(): Moment {
    return moment(this.model.startTime + ' ' + this.startTimeMeridian, [
      'h:mm A',
    ]);
  }

  getServiceTotal() {
    let serviceTotal = 0;
    this.services.forEach((el) => {
      if (!el.requiredError && el.valid) {
        if (el.name !== '' && el.cost !== '') {
          serviceTotal += this.numFormatter.unMaskPrice(el.cost);
        }
      }
    });
    return serviceTotal;
  }

  getDiscountTotal() {
    let serviceTotal = 0;
    this.discounts.forEach((el) => {
      if (!el.requiredError && el.valid) {
        if (el.name !== '' && el.amount !== '') {
          serviceTotal += this.numFormatter.unMaskPrice(el.amount);
        }
      }
    });
    return serviceTotal;
  }

  openCrewModal() {
    const dialogSub = this.dialogService.CreateCrewMember().subscribe((res) => {
      if (res) {
        console.log(res);
        // make crew a userId
        const crewUser = {
          password: 'resetyourpassword',
          email: res.crewMember.email,
          paypalEmail: res.crewMember.paypalEmail,
          firstName: res.crewMember.firstName,
          lastName: res.crewMember.lastName,
          phoneNumber: res.crewMember.phoneNumber,
          city: res.crewMember.city,
          state: res.crewMember.state,
          zip: res.crewMember.zip,
          street: res.crewMember.mailingAddress,
          username: res.crewMember.email,
        };
        this.enroll(crewUser);
      }
    });
    this.subs.push(dialogSub);
  }

  async enroll(crewMember: any) {
    await this.userDAO.checkForUserId(crewMember.email).subscribe((user) => {
      if (user) {
        const crewData = {
          userId: user.id,
        };
        this.onEnrolledCrew(crewData);
        this.userDAO.addRoleToExistingUser('Crew', crewData.userId).subscribe();
      } else if (user === null) {
        const userCreationSub = this.userDAO
          .enrollCrewUser(crewMember)
          .subscribe(
            (createdUser: User) => {
              createdUser.password = crewMember.password;
              const crewData: Partial<CrewMember> = {
                userId: createdUser.id,
              };
              this.onEnrolledCrew(crewData);
            },
            () => {
              console.log('enrollment failed');
            },
          );
        this.subs.push(userCreationSub);
      }
    });
  }

  onEnrolledCrew(crewData: any) {
    this.crewMemberDao.addCrewMemberToUser(crewData).subscribe((crew) => {
      this.crewMembers.push({ id: crew.id, user: crew.user });
      this.filteredCrew = this.charterForm.controls.crew.valueChanges.pipe(
        startWith(''),
        map((name) => this.filterCrew(name)),
      );
      this.snackBar.open('Created Crew Member');
    });
  }

  removeCrewMember(id) {
    this.addedCrew = this.addedCrew.filter((member) => {
      return member.id !== id;
    });
    this.updateCharterPricing();
    this.crewIds = [];
    if (this.addedCrew) {
      this.addedCrew.forEach((crewMember) => {
        this.crewIds.push(crewMember.id);
      });
    }
    console.log(this.charterPayoutRequest);
  }

  addCrewAndServicesToModel() {
    const crew = [];
    const services = [];
    const discounts = [];
    this.addedCrew.forEach((crewMember) => {
      if (crewMember.user.firstName !== '') {
        crew.push({
          id: crewMember.id,
          user: {
            id: crewMember.user.id,
            firstName: crewMember.user.firstName,
            lastName: crewMember.user.lastName,
            email: crewMember.user.email,
            phoneNumber: crewMember.user.phoneNumber,
          },
        });
      }
    });
    this.services.forEach((el) => {
      if (!el.requiredError && el.valid) {
        if (el.name !== '' && el.cost !== '') {
          services.push({
            name: el.name,
            cost: this.numFormatter.unMaskPrice(el.cost),
            show: el.show,
          });
        }
      }
    });
    this.discounts.forEach((el) => {
      if (!el.requiredError && el.valid) {
        if (el.name !== '' && el.amount !== '') {
          discounts.push({
            name: el.name,
            amount: this.numFormatter.unMaskPrice(el.amount),
            show: el.show,
          });
        }
      }
    });
    this.model.crew = crew;
    const serviceTotal = this.getServiceTotal();
    const discountTotal = this.getDiscountTotal();
    this.model.serviceTotal = this.numFormatter.unMaskPrice(
      serviceTotal.toString(),
    );
    this.model.discountTotal = this.numFormatter.unMaskPrice(
      discountTotal.toString(),
    );
    this.model.services = services;
    this.model.discounts = discounts;
  }

  public hasUnavailable(event): void {
    this.snackBar.open(
      'Vessel unavailable.  You can edit the vessel availability in vessel management.',
      null,
      {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['orange-snackbar'],
      },
    );
  }

  public hasAllocations(event): void {
    this.showAllocationWarning = true;
  }

  public selectedDate(event: Moment): void {
    this.date = event.format(this.charterDateFormatSpecification);
    this.checkForMatchingProducts();
    this.updateCharterPricing();
  }

  public selectedEvent(eventInfo: any): void {
    this.dialogService.HelpDialog(eventInfo.dialogInfo);
  }

  public deleteEvent(): void {
    this.appCalendarComponent.deleteByTitle(
      ConstantMan.APP_CALENDAR.CHARTER_PLACEHOLDER,
    );
    this.showAllocationWarning = false;
    this.date = '';
  }

  displayPriceDetails(): void {
    console.log(this.model);
    if (this.selectedCaptain && !this.model.captain) {
      this.model.captain = this.selectedCaptain;
    }
    this.model.duration = this.getIntegerFromDurationRadio();
    const buildPayoutsSub = this.payoutDao
      .charterPayoutRequest({
        charterId: null,
        captainChangeId: this.model.captainId,
        crewMemberIds: this.crewIds,
        partialCharter: this.model,
        date: this.date,
      })
      .subscribe((payouts) => {
        if (this.selectedBoat && payouts && payouts.length > 0) {
          this.dialogService.CharterPriceDetailDialog(
            'all',
            payouts,
            this.getDurationTypeForCalcService(),
            this.customDuration,
            this.selectedBoat,
            this.model.discounts,
            this.model.services,
            this.isMobile,
            this.selectedBoat.vesselRates,
            this.model as Charter,
            false,
          );
        } else {
          console.log('must select boat first and have payouts');
        }
      });
    this.subs.push(buildPayoutsSub);
  }

  checkConflictsBeforeSubmit() {
    this.model.customerPhoneNumber = this.E164PhoneNumber;
    this.setDateAndTimes();
    const conflictRequest: CharterConflictRequest = {
      date: this.model.date,
      endTime: this.model.charterEndTime,
      startTime: this.model.startTime,
      vesselId: this.model.vesselId,
    };
    console.log('submit');
    const productConflictSub = this.vesselAvailabilityPreferencesDAO
      .charterHasProductConflicts(this.model.vesselId, conflictRequest)
      .subscribe((productConflictResponse) => {
        if (productConflictResponse) {
          this.adminWarningModal(conflictRequest, productConflictResponse);
        } else {
          console.log('This charter does not conflict with any products');
          this.submit();
        }
      });
    this.subs.push(productConflictSub);
  }

  getAddOnsForVessel(pricingMetaData: PricingMetaData): {
    optionalAddOns: CustomerAddOn[];
    requiredAddOns: CustomerAddOn[];
  } {
    let product = pricingMetaData.product.find(
      (x) => x?.duration === this.getIntegerFromDurationRadio(),
    );
    console.log({ product });
    if (product) {
      return {
        optionalAddOns: product.optionalAddOns,
        requiredAddOns: product.requiredAddOns,
      };
    } else {
      product = pricingMetaData.product.find((x) => x?.duration === 4);

      if (product) {
        return {
          optionalAddOns: product.optionalAddOns,
          requiredAddOns: product.requiredAddOns,
        };
      } else {
        product = pricingMetaData.product.find((x) => x?.duration === 8);

        if (product) {
          return {
            optionalAddOns: product.optionalAddOns,
            requiredAddOns: product.requiredAddOns,
          };
        } else {
          return { optionalAddOns: [], requiredAddOns: [] };
        }
      }
    }
  }

  handlePreSubmission() {
    // handle all checks and chicken tests prior to submission
    return new Observable((observer) => {
      console.log(this.model.pricingMetaData);
      const { optionalAddOns, requiredAddOns } = this.getAddOnsForVessel(
        this.model.pricingMetaData,
      );
      const extraGuestAddOn = requiredAddOns.find(
        (x) => x.unitType === RequiredAddOnUnitType.PER_PERSON_ABOVE_LIMIT,
      );
      let requiredAddOnsTotal = 0;
      if (extraGuestAddOn) {
        const extraGuestCount =
          this.model.numOfPassengers - extraGuestAddOn.minQuantity;
        extraGuestAddOn.quantity = extraGuestCount > 0 ? extraGuestCount : 0;
        requiredAddOnsTotal = getAddOnCost(extraGuestAddOn, true);
      }

      if (optionalAddOns.length) {
        const dialogRef = this.dialogService.CustomerAddOnsDialog(
          optionalAddOns,
          this.model.charterBaseFee,
          requiredAddOnsTotal,
          null,
          null,
          this.model.duration,
          null,
          false,
          this.isMobile,
          false,
        );
        dialogRef.afterClosed().subscribe((selectedAddOns) => {
          if (selectedAddOns) {
            this.model.pricingMetaData.addOns = [...selectedAddOns];
            if (extraGuestAddOn) {
              this.model.pricingMetaData.addOns.push(extraGuestAddOn);
            }
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.complete();
        });
      } else {
        if (requiredAddOns.length) {
          this.model.pricingMetaData.addOns = [extraGuestAddOn];
        }
        observer.next(true);
        observer.complete();
      }
    });
  }

  async submit() {
    const canSubmit = await this.handlePreSubmission().toPromise();

    if (canSubmit) {
      console.log(this.model.pricingMetaData);
      this.setCharterVariablesForSubmit();
      const createCharterSub = this.charterDao
        .createCharter(this.model)
        .subscribe((createdCharter) => {
          if (this.charterNotes) {
            this.createCharterNote(createdCharter.id);
          }
          this.loading = false;
          this.router.navigate(['manage', 'charters'], {
            queryParams: { status: 'lead' },
          });
        });
      this.subs.push(createCharterSub);

      this.addCaptainToPreferredCheck();
    }
  }

  adminWarningModal(
    conflictRequest: CharterConflictRequest,
    productConflict: ProductConflict[],
  ): void {
    const adminWarningDialog = this.dialogService
      .adminWarningDialog(conflictRequest, productConflict)
      .subscribe((confirmCharter) => {
        if (confirmCharter) {
          this.submit();
        }
      });
    this.subs.push(adminWarningDialog);
  }

  ngOnDestroy(): void {
    this.initModel();
    unsubscribeFromAll(this.subs);
  }

  private getIntegerFromDurationRadio(): number {
    let returnHours: number = null;
    switch (this.durationRadio) {
      case 'halfDayDuration':
        returnHours = this.halfDayDuration;
        break;
      case 'fullDayDuration':
        returnHours = this.fullDayDuration;
        break;
      default:
        returnHours = this.customDuration;
        break;
    }
    return returnHours;
  }

  private getDurationTypeForCalcService(): 0 | 4 | 8 {
    let returnHours: 0 | 4 | 8 = null;
    switch (this.durationRadio) {
      case 'halfDayDuration':
        returnHours = 4;
        break;
      case 'fullDayDuration':
        returnHours = 8;
        break;
      default:
        returnHours = 0;
        break;
    }
    return returnHours;
  }

  private addCaptainToPreferredCheck(): void {
    let needToAddCaptain = false;
    this.preferredCaptains = [];
    this.selectedBoat.vesselCaptainMap.forEach((captain) => {
      if (captain && captain.captain) {
        this.preferredCaptains.push(captain.captain.id);
      }
    });
    if (
      this.selectedCaptain &&
      this.preferredCaptains.includes(this.selectedCaptain.id) === false
    ) {
      this.preferredCaptains.push(this.selectedCaptain.id);
      needToAddCaptain = true;
    }

    if (needToAddCaptain) {
      const captainSub = this.boatDao
        .updateVesselCaptains(this.selectedBoat.id, this.preferredCaptains)
        .subscribe((_) => {
          console.log('preferred captain added');
        });
      this.subs.push(captainSub);
    }
  }

  private setCharterVariablesForSubmit() {
    this.model.fuelCost = this.numFormatter.unMaskPrice(this.model.fuelCost);
    this.addCrewAndServicesToModel();
    this.model.charterBaseFee = this.numFormatter.unMaskPrice(
      this.model.charterBaseFee,
    );
    // @ts-ignore
    this.model.createdAt = new Date().toUTCString();
    this.model.createdById = this.user.id;
    this.loading = true;
    this.model.date = moment(this.model.date).format(dateSessionStorageFormat);
    delete this.model.boat;
    delete this.model.captain;
  }

  private updateCharterPricing() {
    if (
      this.selectedBoat?.id &&
      this.date &&
      this.getIntegerFromDurationRadio() > 0
    ) {
      const productRatesSub = this.vesselRateDAO
        .getProductAdjustedRates(
          this.selectedBoat.id,
          this.date,
          this.getIntegerFromDurationRadio(),
        )
        .subscribe((productAdjustedRates) => {
          this.model.charterBaseFee = productAdjustedRates.charterBaseFee;
          this.model.boat.vesselRates = this.model.originalRates =
            productAdjustedRates.vesselRates;
          this.showPriceDetailButton = true;
        });
      this.subs.push(productRatesSub);
    }
  }

  private checkForMatchingProducts() {
    if (this.date && this.durationRadio) {
      const vesselProductSub = this.charterVesselAvailabilityDAO
        .getAvailableProductsForDay(
          this.selectedBoat.id,
          moment(this.date, this.charterDateFormatSpecification)
            .utc()
            .startOf('day'),
        )
        .subscribe((productValues) => {
          if (!this.productValuesIncludesSelectedDuration(productValues)) {
            this.model.pricingMetaData = {
              legacyPricing: true,
            };
            this.snackBar.open(
              'No available products for selected configuration, defaulting to legacy pricing.',
              null,
              {
                duration: 5000,
                verticalPosition: 'top',
              },
            );
          } else {
            this.model.pricingMetaData = {
              legacyPricing: false,
              product: productValues.filter((product) => {
                return product.duration === this.getIntegerFromDurationRadio();
              }),
              addOns: [],
            };
          }
        });

      this.subs.push(vesselProductSub);
    }
  }

  private productValuesIncludesSelectedDuration(
    productValues: BuyflowProductOffering[],
  ) {
    if (productValues && productValues.length) {
      return (
        productValues &&
        productValues.some(
          (product) => product.duration === this.getIntegerFromDurationRadio(),
        )
      );
    }
    return false;
  }

  private resetCaptainList(boat: Vessel): void {
    this.captainList = [];
    boat.vesselCaptainMap.map((boatCap) => {
      if (
        boatCap.captain &&
        boatCap.captain.status === 'active' &&
        boatCap.captain.user.status === 'active'
      ) {
        this.captainList.push(boatCap.captain);
      }
    });
  }

  private createCharterNote(charterId: number) {
    const noteSub = this.charterNoteDAO
      .saveNote(charterId, this.charterNotes)
      .subscribe();
    this.subs.push(noteSub);
  }
}
